<template>
  <div>
    <inertia-head>
      <title id="inertiaTitle">{{ header }}</title>
    </inertia-head>
    <menuTop :fixed="showFixedBar" />
    <menuTop :transparent="true" v-if="transparent" />
    <flashMessage />
    <div
      id="fullscreenLoader"
      class="fixed inset-0 top-0 left-0 z-50 flex-col items-center justify-center hidden w-full h-full bg-gray-900 opacity-50 flex"
    >
      <svg
        class="w-5 h-5 mr-3 -ml-1 text-white animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <p
        id="fullscreenLoaderMessage"
        class="mt-4 text-sm font-medium text-white uppercase"
      ></p>
    </div>
    <div id="content" ref="content" :class="!transparent && 'pt-28'">
      <slot></slot>
    </div>
    <footerBottom ref="footer" />
    <cookieBanner />
    <CallToAction />
  </div>
</template>

<script>
import menuTop from "./Menu/menu.vue";
import footerBottom from "./footer.vue";
import flashMessage from "./flashMessage.vue";
import cookieBanner from "./cookieBanner.vue";
import CallToAction from "./CallToAction.vue";
import { Inertia } from "@inertiajs/inertia";
export default {
  components: {
    menuTop,
    footerBottom,
    flashMessage,
    cookieBanner,
    CallToAction,
  },
  props: ["transparent", "fixed", "title"],
  data() {
    return {
      header: this.title == undefined ? "Youverse" : this.title + " | Youverse",
      showFixedBar: !this.transparent,
      cookieName: "allow_cookies",
    };
  },

  mounted() {
    this.moveHubSpotIfCookieMissing();
    this.getDataFromGoogleAds();

    this.$nextTick(function () {
      //put inertia title before blade title
      if (document.getElementById("inertiaTitle")) {
        document
          .getElementsByTagName("head")[0]
          .prepend(document.getElementById("inertiaTitle"));
      }
    });

    if (this.$page.props.flash.message != null) {
      this.$store.commit("showFlashMessage", {
        message: this.$page.props.flash.message,
        type: this.$page.props.flash.message_type,
      });
    }

    //Send page to Google Analytics
    this.$gtag.pageview(window.location.pathname);

    if (this.transparent) {
      window.addEventListener("scroll", this.onScroll);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    moveHubSpotIfCookieMissing() {
      if (this.getCookie(this.cookieName) == "") {
        this.addStyles();
      }
    },

    addStyles() {
      let existingStyle = document.getElementById("hubspot-messages-id");
      if (!existingStyle) {
        const style = document.createElement("style");
        style.id = "hubspot-messages-id";
        style.type = "text/css";
        style.innerText =
          "div#hubspot-messages-iframe-container { bottom: 100px !important; }";

        document.head.appendChild(style);
      }
    },

    onScroll(e) {
      window.top.scrollY > 70
        ? (this.showFixedBar = true)
        : (this.showFixedBar = false);
    },

    setCookieUTM(name, value, expDays = 7) {
      const d = new Date();
      d.setTime(d.getTime() + expDays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie =
        name + "=" + (value || "") + "; " + expires + "; path=/";
    },

    getCookie() {
      let name = this.cookieName;
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    getDataFromGoogleAds() {
      const params = new URL(window.location.href).searchParams;
      const utmFields = ["utm_source", "utm_medium", "utm_campaign"];

      utmFields.forEach((utmField) => {
        let utmValue = params.get(utmField);
        if (utmValue) {
          this.setCookieUTM(utmField, utmValue);
        }
      });
    },
  },
};
</script>

<style>
.pu-skeleton {
  line-height: unset !important;
  background-color: rgb(238, 238, 238);
  background-image: linear-gradient(
    90deg,
    rgb(238, 238, 238),
    rgb(245, 245, 245),
    rgb(238, 238, 238)
  );
  animation: 1.5s ease-in-out 0s infinite normal none running SkeletonLoading;
}

.paddle-frame-overlay {
  position: fixed !important;
}
</style>